var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w",attrs:{"id":"nav"}},[_c('en-category'),_vm._v(" "),_c('ul',{staticClass:"nav-list"},_vm._l((this.$store.getters.navList),function(nav){return _c('li',{key:nav.navigation_id},[(nav.url.indexOf('http') == 0)?_c('a',{attrs:{"href":nav.url,"target":"_self"}},[_vm._v(_vm._s(nav.navigation_name))]):_c('router-link',{attrs:{"to":nav.url}},[_vm._v(_vm._s(nav.navigation_name))])],1)}),0)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9274f64","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = null
// module chunks = 